import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-prototype-of.js";
export function obj2query(obj) {
  var str = '';
  Object.keys(obj).forEach(function (k) {
    if (typeof obj[k] !== 'undefined') {
      str += encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]) + "&";
    }
  });
  return str.slice(0, -1);
}
export function query2obj(query) {
  var obj = {};
  query.split('&').forEach(function (part) {
    var brr = part.split('=');
    // if (!brr.length) return;
    var key = brr.shift();
    if (!key) return;
    obj[decodeURIComponent(key)] = decodeURIComponent(brr.join('='));
  });
  return obj;
}

/**
 *是否为纯粹的对象
 * @export
 * @param {*} obj
 * @return {*} true or false
 */
export function isPlainObject(obj) {
  if (!obj || typeof obj !== 'object') return false;
  var proto = Object.getPrototypeOf(obj);
  if (!proto) return true;
  var construct = Object.prototype.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof construct === 'function' && construct === Object; // 构造函数是Object
}

/**
 *是否为纯粹的对象或数组
 * @export
 * @param {*} obj
 * @return {*} true or false
 */
export function isPlainObjectOrArray(obj) {
  // 支持参数类型为数组
  if (Array.isArray(obj)) {
    return true;
  }
  return isPlainObject(obj);
}